// 20.1.2.3 Number.isInteger(number)
var isObject = require('./_is-object');
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_is-integer.js
// module id = 265
// module chunks = 48 49 50 51